// extracted by mini-css-extract-plugin
export default {"container":"App_container__4qrIp","alerts":"App_alerts__nA05R"};